import styled from 'styled-components'
import posed from 'react-pose'
import Icon from '../../components/Icon'

export const SearchStyled = styled.div`
`

export const SearchButton = styled.div`
    margin-left: 15px;
    cursor: pointer;
`

const SearchWrapperPosed = posed.div({
    enter: {
        height: 'calc(100vh - 110px)'
    },
    exit: {
        height: '0vh'
    }
});

export const SearchWrapper = styled(SearchWrapperPosed)`
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    width: 100%;
    height: calc(100vh - 110px);
    background: ${({ theme }) => theme.white};
    z-index: 3;
    overflow: hidden;
`
export const SearchContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`

export const SearchInputContainer = styled.div`
    background: ${({ theme }) => theme.background};
`

export const ItemsTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.brownGrey};
    margin: 10px 0;
`

export const Items = styled.div`
    width: 100%;
    max-width: 1024px;
    padding-left: 10px;
    padding-right: 10px;
    margin: 0 auto;
    overflow-y: auto;
    height: 100%;
    flex: 1;
`

export const SearchBox = styled.form`
    display: flex;
    align-items: center;
`
export const SearchClose = styled.div`
    margin: 10px 0;
    padding: 10px 30px;
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.greyishBrown};
    cursor: pointer;
`

export const Char = styled.span`
  color: ${({ theme }) => theme.green};
`

export const StyledSearchHint = styled.div`
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    height: 28px;
`

export const StyledSearchHintIcon = styled(Icon).attrs(({ theme }) => ({
    color: theme.grassyGreen,
}))`
    margin-right: 5px;
`


export const StyledSearchHintText = styled.span`
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.grassyGreen};
    font-size: 12px;
`
